import { accountAxiosInstance } from "@/services/axios";

export const registerVendor = async (body: {
  mobile_number: string ;
  email: string;
  business_name: string;
  area_name: string;
  pin_code: string;
  fssai_number?: string;
  gst_number?: string;
  vendor_contact_name: string;
  latitude: number;
  longitude: number;
}) => {
  const response = await accountAxiosInstance.post("/vendor_register", body);
  return response.data;
};
